<template>
  <o-form-group
    :id="this_id"
    :form-state="formState"
    :label="label"
    :message="errorMessages"
    :nolabel="nolabel"
    :type="{ 'is-danger': hasError }"
  >
    <codemirror :options="codeMirrorOptions" :value="value" @input="on_input" />
  </o-form-group>
</template>

<script>
import FormComponentMixin from "vue-ocom/mixins/form_component_mixin.js";
import OFormGroup from "vue-ocom/components/forms/OFormGroup.vue";
import { codemirror } from "vue-codemirror";
import "codemirror/lib/codemirror.css";
import "codemirror/theme/cobalt.css";
import "codemirror/mode/go/go.js";
import "codemirror/addon/display/autorefresh.js";
import "./tengo.js";

export default {
  name: "OCodeMirror",
  components: {
    OFormGroup,
    codemirror,
  },
  mixins: [FormComponentMixin],
  computed: {
    codeMirrorOptions() {
      return {
        mode: "tengo",
        theme: "cobalt",
        lineNumbers: true,
        lineWrapping: true,
        tabSize: 2,
        autoRefresh: true,
      };
    },
  },
  methods: {},
};
</script>

<style>
.CodeMirror {
  min-height: 500px;
  height: auto;
}
</style>
